import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useBindingDriftReport} from '../hooks/useBindingDriftReport.ts';

// FNP-585: read-only detail view of a single binding-drift sweep run. No edit drawer
// / tools — the sweep owns the lifecycle. Renders the run summary, the outcome
// counts, and the per-account findings table.
export const DetailPage = () => {
    const {id: reportId} = useParams();

    if (typeof reportId === 'undefined') {
        throw new Error('reportId is required parameter');
    }

    const {
        record: report,
        loading,
        isError,
        notFound,
    } = useBindingDriftReport(reportId);

    if (loading) {
        return <PlatformLoader message='Loading binding drift report...Please wait'/>;
    }

    // Never hang on the loader: once the query has settled, a missing record or an
    // error gets an explicit message rather than an indefinite spinner.
    if (isError || notFound || !report) {
        return (
            <Alert color='red' title='Binding drift report not found'>
                No binding drift report found for id <code>{reportId}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={report.id}
            pageNavigation={<EditPageNavigation component={report}/>}
        >
            <Stack gap='lg'>
                <Profile record={report}/>
            </Stack>
        </FormPageLayout>
    );
};
